import { GoogleLoginProps, useGoogleOneTapLogin, useGoogleOAuth } from "@react-oauth/google"
import { useDispatch, useSelector } from "react-redux"
import { GOOGLE_SIGN_IN_FAILED_ERROR } from "../../crm-integrations/authorization/ducks/constants"
import { RootState, authActions } from "../ducks"

export const useGoogleAuth = () => {
  const dispatch = useDispatch()
  const googleErrors = useSelector<RootState, string>(({ authorization }) => authorization.googleErrors)

  const resetGoogleErrors = () => {
    dispatch(authActions.setGoogleErrors(""))
  }

  const onSuccess = ({ credential }: { credential: string }) => {
    if (credential) {
      dispatch(authActions.googleLogin({ credential }))
    }
  }

  const onError: GoogleLoginProps["onError"] = () => {
    dispatch(authActions.setGoogleErrors(GOOGLE_SIGN_IN_FAILED_ERROR))
  }

  const { scriptLoadedSuccessfully } = useGoogleOAuth()

  const handleGoogleSignIn = () => {
    resetGoogleErrors()

    if (!scriptLoadedSuccessfully) {
      return
    }

    const googleSignInButton = document.querySelector(".google-sign-in div[role=button]") as HTMLElement
    googleSignInButton.click()
  }

  useGoogleOneTapLogin({ onSuccess, onError })

  return {
    googleErrors,
    onSuccess,
    onError,
    handleGoogleSignIn
  }
}
